var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"mx-auto"},[_c('youtube',{staticStyle:{"overflow":"hidden"},attrs:{"video-id":_vm.videoId,"player-width":"100%","iframeMode":true},on:{"ready":_vm.ready}}),_c('v-card-title',{staticClass:"pt-1 pb-2"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('v-card-text',{staticClass:"text--primary"},[_vm._v(" "+_vm._s(_vm.text)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }